import { Image, View } from "react-native";
import { ResidentModel } from "app/services/api/types/residents/models/ResidentModel";

interface Props {
  resident?: ResidentModel;
}

export default function StatusFlagContent({ resident }: Props) {
  return (
    <View className="flex flex-1 flex-wrap flex-row gap-2">
      {resident?.status_flags?.map((flag) =>
        flag.icon?.url ? (
          <Image
            key={flag.id}
            source={{ uri: flag.icon.url }}
            className="w-8 h-8 object-contain"
            resizeMode="contain"
          />
        ) : null,
      )}
    </View>
  );
}
